module.exports = {"id":"215565","name":"Matt Miazga","rating":"73","photo":"./data/images/photos/0/215565.png","club":{"name":"Vitesse","logo":"./data/images/clubs/Vitesse.png"},"positions":["DC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MattMiazga0.json
// module id = 2894
// module chunks = 0